/* eslint-disable react/no-unescaped-entities */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-nested-ternary */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-else-return */
/* eslint-disable padding-line-between-statements */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useRef, useState } from 'react';
import 'react-h5-audio-player/lib/styles.css';
import AudioPlayer from 'react-h5-audio-player';
import { Button, TextField, useMediaQuery, useTheme } from '@material-ui/core';
import ReactHlsPlayer from 'react-hls-player';
import { useMutation } from 'react-fetching-library';
// import WaveSurfer from 'wavesurfer.js';
import clsx from 'clsx';
import qs from 'qs';
import { useHistory } from 'react-router-dom';

import { ClipFinalProps } from './ClipFinalSection.types';
import { useStyles } from './ClipFinalSection.styles';
import { Form, Typography } from 'shared/components';
import { nlpSelfSenderTimes } from 'api/actions/participantSelection/participantClipping.actions';
import { useLocale } from 'shared/hooks';
import pauseVideoIcon from 'assets/icons/pause-video.png';
import playVideoIcon from 'assets/icons/play-video.png';
import { AppRoute } from 'app/routing/AppRoute.enum';

export const ClipFinalSelection = ({
  // pausedTime,
  activeStep,
  setActiveStep,
  audioStartTime,
  audioEndTime,
  sliderValue,
  audioSliderValue,
  streamURL,
  audioURL,
  setIsSuccess,
  defaultFirstName,
  defaultLastName,
  setUtcTime,
  // isFromCeremony,
  clipAudioTime,
  renderLimit,
  participantId,
  videoStartSeconds,
  videoEndSeconds,
  setSnackbarMessage,
}: ClipFinalProps) => {
  const styles = useStyles();
  const { push } = useHistory();
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const playerRef = useRef<HTMLVideoElement | null>(null);
  const audioPlayerRef = useRef<any>(null);
  const [isHovered, setIsHovered] = useState(false);
  const endedAt = videoEndSeconds ?? audioStartTime + clipAudioTime;
  const params: any = qs.parse(window.location.href.split('?')[1]);
  const { formatMessage } = useLocale();
  const [firstName, setFirstName] = useState(defaultFirstName || ''); // Initialize with empty or default value
  const [lastName, setLastName] = useState(defaultLastName || '');
  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  const [audioCurrentTime, setAudioCurrentTime] = useState(0);

  // START - Intentionally commented
  // *** Previously used to calculate initial video times for students when processing transcripts with OpenAI.
  // *** Now the Gemini workflow provides video times. If Gemini does not detect walking times,
  // *** the NLP service will set VideoStartTime = audioStartTime and VideoEndTime = VideoStartTime + 15.
  // const subtractValue = audioStartTime - 6;
  // const videoDifference = sliderValue[1] - sliderValue[0];
  // const videoEndValue = videoEndSeconds ?? audioStartTime + videoDifference;
  // const audioStart = audioSliderValue.length === 2 ? audioSliderValue[0] : isFromCeremony ? subtractValue : audioStartTime - 1.5;
  // const audioEnd = audioSliderValue.length === 2 ? audioSliderValue[1] : videoDifference ? videoEndValue : audioEndTime + 1;
  // END - Intentianally commented

  const audioStart = audioSliderValue.length === 2 ? audioSliderValue[0] : audioStartTime - 1.5;
  const audioEnd = audioSliderValue.length === 2 ? audioSliderValue[1] : audioEndTime + 1;

  const duration = audioEnd - audioStart;

  const { id } = params;

  const { mutate, loading } = useMutation(nlpSelfSenderTimes(id));

  function formatTime(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = Math.floor(seconds % 60); // Floor to remove decimals

    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  }

  const handleSuccessCallback = () => {
    setIsSuccess(true);
  };

  const handleConfirmationSubmit = async () => {
    const body = {
      audioEndFrame: formatTime(audioEnd),
      audioStartFrame: formatTime(audioStart),
      videoEndFrame: formatTime(sliderValue[1] ?? videoEndSeconds),
      videoStartFrame: formatTime(sliderValue[0] ?? videoStartSeconds),
      firstName: firstName !== '' ? firstName : defaultFirstName,
      lastName: lastName !== '' ? lastName : defaultLastName,
    };

    const utcTime = new Date().toISOString(); // Get the current UTC time
    setUtcTime(utcTime);

    try {
      await mutate(body);
      handleSuccessCallback();
    } catch (error) {
      // Error handled silently
    }
  };

  const handleClick = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
        if (sliderValue.length === 2) {
          videoRef.current.currentTime = sliderValue[0];
          if (videoRef.current.currentTime > sliderValue[1]) {
            videoRef.current.play();
          }
        } else {
          videoRef.current.currentTime = videoStartSeconds || audioStartTime;

          if (videoRef.current.currentTime >= endedAt) {
            videoRef.current.play();
          }
        }
      }
      setIsPlaying(!isPlaying);
    }
  };

  useEffect(() => {
    setFirstName(defaultFirstName || '');
    setLastName(defaultLastName || '');
  }, [defaultFirstName, defaultLastName]);

  useEffect(() => {
    const video = videoRef.current;

    window.scrollTo(0, 0);

    if (video) {
      if (sliderValue.length === 2) {
        // If sliderValue is provided, use it as the start and end time
        video.addEventListener('loadedmetadata', () => {
          video.currentTime = sliderValue[0] || videoStartSeconds;
        });

        const handleTimeUpdate = () => {
          if (video.currentTime >= sliderValue[1]) {
            video.currentTime = sliderValue[0]; // Reset to the fallback start time
            video.play();
          }
        };

        video.addEventListener('timeupdate', handleTimeUpdate);

        return () => {
          video.removeEventListener('timeupdate', handleTimeUpdate);
        };
      } else {
        video.addEventListener('loadedmetadata', () => {
          video.currentTime = audioStartTime;
        });

        const handleTimeUpdate = () => {
          if (video.currentTime >= endedAt) {
            video.currentTime = audioStartTime; // Reset to the fallback start time
            video.play(); // Continue playing
          }
        };

        video.addEventListener('timeupdate', handleTimeUpdate);

        return () => {
          video.removeEventListener('timeupdate', handleTimeUpdate);
        };
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audioStartTime, sliderValue]);

  useEffect(() => {
    const player = audioPlayerRef.current?.audio?.current;

    if (player) {
      player.currentTime = audioStart;

      const handleTimeUpdate = () => {
        const relativeTime = player.currentTime - audioStart;
        setAudioCurrentTime(relativeTime);

        if (player.currentTime >= audioEnd) {
          player.currentTime = audioStart;
          player.play();
        }
      };

      player.addEventListener('timeupdate', handleTimeUpdate);

      return () => {
        player.removeEventListener('timeupdate', handleTimeUpdate);
      };
    }
  }, [audioStart, audioEnd]);

  const handlePlay = () => {
    const player = audioPlayerRef.current?.audio?.current;
    if (player) {
      const setStartTime = () => {
        player.currentTime = audioStart;
        player.removeEventListener('playing', setStartTime);
      };

      if (player.readyState >= 1) {
        player.currentTime = audioStart;
      } else {
        player.addEventListener('playing', setStartTime);
      }
    }
  };

  const handleSeek = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const player = audioPlayerRef.current?.audio?.current;
    if (player) {
      const seekPercentage = event.nativeEvent.offsetX / event.currentTarget.offsetWidth;
      const seekTime = audioStart + seekPercentage * duration;
      player.currentTime = seekTime;
      setAudioCurrentTime(seekTime - audioStart);
    }
  };

  const formatTime1 = (time: number) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  function pauseVideo() {
    const vi = playerRef.current;

    if (vi) {
      vi.pause();
    }
  }

  // const handleBack = () => {
  //   setActiveStep(activeStep - 1);
  // };

  const EditMyClip = () => {
    setActiveStep(activeStep - 2);
  };

  const handleRenderConfirmation = () => {
    if (renderLimit.successCount === renderLimit.limit) {
      setSnackbarMessage('You have reached the render limit');
    } else {
      handleConfirmationSubmit();
    }
  };

  return (
    <>
      <Form
        onSubmit={handleRenderConfirmation}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit} noValidate>
            <div className={styles.container}>
              <div className={styles.logoContainer}>
                <div className={styles.gridItem}>
                  <div className={styles.videoContentContainer}>
                    <div>
                      <Typography className={styles.subTitle}>
                        {formatMessage({ id: 'studentSelection.clip.final.video' })}
                      </Typography>
                      <Typography className={styles.subTitle}>
                        {formatMessage({ id: 'studentSelection.clip.final.video.note' })}
                      </Typography>
                      {/* <Typography className={styles.talkstageclip}>Video</Typography> */}
                    </div>

                    <div
                      className={styles.playerContainer}
                      onMouseEnter={() => !isMobile && setIsHovered(true)}
                      onMouseLeave={() => !isMobile && setIsHovered(false)}
                    >
                      <div className={styles.ledgerText}>Video</div>

                      {(isHovered || isMobile || !isPlaying) && (
                        <div className={styles.playButton} onClick={handleClick} data-testid="play">
                          {isPlaying ? (
                            // eslint-disable-next-line jsx-a11y/accessible-emoji
                            !isMobile && <img src={pauseVideoIcon} width="24px" height="24px" alt="pause" />
                          ) : (
                            // eslint-disable-next-line jsx-a11y/accessible-emoji
                            <img src={playVideoIcon} width="24px" height="24px" alt="play" />
                          )}
                        </div>
                      )}
                      <div style={{ marginTop: '1rem' }} onClick={() => isMobile && setIsHovered(!isHovered)}>
                        <ReactHlsPlayer
                          playerRef={videoRef}
                          src={streamURL}
                          preload="metadata"
                          // width="80%"
                          height="95%"
                          controlsList="nodownload"
                          disablePictureInPicture
                          // controls
                          playsInline
                          onChange={pauseVideo}
                          onLoadedMetadata={() => {
                            if (videoRef.current) {
                              videoRef.current.currentTime = sliderValue[0] ?? (videoStartSeconds || audioStartTime);
                            }
                          }}
                          className={styles.videoContainer}
                          muted
                        />
                        <div style={{ display: 'flex', padding: '0px', margin: '0px', marginLeft: '10px' }}>
                          <div className={styles.inTimeText} />

                          <div className={styles.outTimeText} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={clsx(styles.gridItem, styles.audioContainer)}>
                  <div>
                    <Typography className={styles.subTitle}>
                      {formatMessage({ id: 'studentSelection.clip.final.audio' })}
                    </Typography>
                    <div className={styles.audioContainerSub}>
                      <div className={styles.ledgerText}>Audio</div>
                      <div style={{ width: '100%' }}>
                        <AudioPlayer
                          src={audioURL}
                          ref={audioPlayerRef}
                          preload="metadata"
                          showJumpControls={false}
                          onPlay={handlePlay}
                          customAdditionalControls={[]}
                          customVolumeControls={[]}
                          customProgressBarSection={[
                            <>
                              <div key="current-duration" style={{ marginRight: '10px' }}>
                                {formatTime1(audioCurrentTime)} / {formatTime1(duration)}
                              </div>
                              <div
                                key="custom-progress"
                                style={{
                                  flexGrow: 1,
                                  height: '5px',
                                  backgroundColor: '#ddd',
                                  position: 'relative',
                                  cursor: 'pointer',
                                }}
                                onClick={handleSeek}
                              >
                                <div
                                  style={{
                                    width: `${(audioCurrentTime / duration) * 100}%`,
                                    height: '100%',
                                    backgroundColor: '#18a957',
                                  }}
                                />
                              </div>
                            </>,
                          ]}
                        />
                        {/* <audio
                                src={audioURL}
                                controls
                                style={{ width: '100%' }}
                                onClick={handlePlayPauseAudio}
                                ref={videoRef2}
                                controlsList="nodownload"
                                className={styles.audioPlayer}
                              /> */}

                        {/* <div className={styles.inOutTimes}>
                              <div className={styles.inTimeText}>
                                <Typography style={{ fontWeight: 'bold' }}>
                                  {audioSliderValue.length === 2
                                    ? formatTime(audioSliderValue[0])
                                    : formatTime(audioStartTime ?? 0)}
                                </Typography>
                                <Typography>In time</Typography>
                              </div>
                              <div className={styles.outTimeText}>
                                <Typography style={{ fontWeight: 'bold' }}>
                                  {audioSliderValue.length === 2
                                    ? formatTime(audioSliderValue[1])
                                    : formatTime(endedAt ?? 0)}
                                </Typography>
                                <Typography>Out time</Typography>
                              </div>
                            </div> */}
                      </div>
                    </div>
                  </div>

                  <div>
                    <Typography className={styles.subTitle}>
                      {formatMessage({ id: 'studentSelection.clip.final.name-edit' })}
                    </Typography>
                    <div className={styles.nameContainerMain}>
                      <div className={styles.ledgerText}>
                        {formatMessage({ id: 'studentSelection.clip.final.name-display' })}
                      </div>
                      <div className={styles.nameContainerMobile}>
                        <TextField
                          label={formatMessage({ id: 'studentSelection.clip.final.form.firstName' })}
                          type="text"
                          size="small"
                          name="firstName"
                          fullWidth
                          variant="outlined"
                          placeholder="Enter your last name as announced"
                          // validate={[length({ max: 50 })]}
                          // className={styles.textLabel}
                          // classes={{ root: styles.textFieldRoot }}
                          value={firstName}
                          // defaultValue={defaultFirstName}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFirstName(e.target.value)}
                          InputLabelProps={{
                            shrink: true, // Ensures the label stays visible even when the field is not focused
                            classes: { root: styles.textLabel }, // Apply custom styles
                          }}
                          InputProps={{
                            classes: { root: styles.textFieldRoot }, // Apply root styles
                          }}
                        />
                        <TextField
                          label={formatMessage({ id: 'studentSelection.clip.final.form.lastName' })}
                          type="text"
                          size="small"
                          name="lastName"
                          fullWidth
                          variant="outlined"
                          // placeholder="Enter your last name as announced"
                          value={lastName}
                          // validate={[length({ max: 50 })]}
                          // className={styles.textLabel}
                          // classes={{ root: styles.textFieldRoot }}
                          // defaultValue={defaultLastName}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLastName(e.target.value)}
                          InputLabelProps={{
                            shrink: true, // Ensures the label stays visible even when the field is not focused
                            classes: { root: styles.textLabel }, // Apply custom styles
                          }}
                          InputProps={{
                            classes: { root: styles.textFieldRoot }, // Apply root styles
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.gridItem} />
                <div className={styles.gridItem}>
                  <div className={styles.buttonContainer}>
                    <div className={styles.actions}>
                      <Button
                        className={styles.confirmButton}
                        onClick={() =>
                          push(
                            `${AppRoute.participantSelection.replace(
                              ':participantId',
                              participantId,
                            )}?isItemMatched=true`,
                          )
                        }
                      >
                        It's Not Me
                      </Button>
                      <Button
                        className={styles.backButton}
                        onClick={() => {
                          EditMyClip();
                        }}
                      >
                        Edit My Clip
                      </Button>
                      <Button
                        className={styles.confirmButton}
                        onClick={() => {
                          handleRenderConfirmation();
                        }}
                        type="submit"
                        disabled={loading}
                      >
                        Confirm
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        )}
      />
    </>
  );
};
